module.exports = __webpack_public_path__ + "media/images/icons/flags/KH-89b1f0cf862ecde3665b5848941380fd.svg";